import React, { lazy } from 'react';


const CommonComponent = lazy(() => import('./index'));

const route = [
  {
    path: '/commons',
    title: 'Common',
    exact: true,
    public: true,
    component: <CommonComponent />,

  },
];

export default route;